import classNames from "classnames";
import React from "react";
import { connectHits } from "react-instantsearch-dom";

import TimeAgo from "javascript-time-ago";
import ReactTimeAgo from "react-time-ago";

import en from "javascript-time-ago/locale/en";
import parseDate from "../helpers/parseDate";

TimeAgo.addDefaultLocale(en);

let colorCount = 0;
const colors = ["blue", "red", "yellow", "green"];

const JobHit = ({ hit }) => {
	const nextBg = colors[colorCount];

	colorCount++;

	if (colorCount === colors.length) {
		colorCount = 0;
	}

	return (
		<div
			className={classNames(
				"rounded-5 p-3 mb-2 text-white",
				`bg-${nextBg}`
			)}
			key={hit.id}
		>
			<h2 className="mb-0 text-white">{hit.title}</h2>
			<p className="fs-5 font-fancy">{hit.location_text}</p>

			<div
				dangerouslySetInnerHTML={{
					__html: hit.summary,
				}}
			/>

			<span className="py-1 mt-1 text-white d-inline-block font-fancy text-decoration-none pe-2 pe-md-3">
				{/* parseDate --> https://stackoverflow.com/questions/24582638/why-does-my-time-ago-filter-work-in-chrome-and-not-safari-or-firefox */}
				{hit.posted_on && (
					<ReactTimeAgo
						date={parseDate(hit.posted_on)}
						locale="en-GB"
						timeStyle="round"
					/>
				)}
			</span>
			<a
				className="px-2 py-1 mt-1 bg-white shadow d-inline-block font-fancy text-decoration-none px-md-3 rounded-4 text-blue me-1"
				href={hit.url}
			>
				Learn More
			</a>
			<a
				className="px-4 py-1 mt-1 bg-white shadow d-inline-block font-fancy text-decoration-none rounded-4 text-blue"
				href={`${hit.url}#apply`}
			>
				Apply Now
			</a>
		</div>
	);
};

const CustomJobHits = ({ hits }) => {
	return (
		<>
			{hits.map((hit) => (
				<JobHit key={hit.objectID} hit={hit} />
			))}
			{!hits.length && (
				<p>No positions available matching the current criteria.</p>
			)}
		</>
	);
};

export default connectHits(CustomJobHits);
